



















































































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PatientMergeSet from './patient-merge-set.vue';
import PatientMergeSearch from './patient-merge-search.vue';
import PatientMergeConfirm from './patient-merge-confirm.vue';
import * as service from '@/services/patients';
import { PacienteAgrupadoParmDTO } from '@/interfaces/patient';

@Component({
  components: {
    PatientMergeSearch,
    PatientMergeSet,
    PatientMergeConfirm
  },
  directives: {}
})
export default class PatientMergeDialog extends BaseComponent {
  @Prop()
  patientOrigin:any

  dialogFlag = false;
  search = null;
  patient = null;
  patientResult = null;
  
  stepper = 0

  public form: any = {
    valid: false,
    rules: {
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    setTimeout(() => {
      this.dialogFlag = true;
    }, 100);
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  step1Ok() {
    return this.patient != null;
  }

  step2Ok() {
    return this.patientResult && this.patientResult.nome;
  }

  @Watch('patient')
  onPatientChange() {
    if (this.step1Ok) {
      this.stepper = 2;
    }
  }

  save() {
    this.loader.start('Processando ...');
    service.saveMergePatient(this.patientResult).subscribe(res => {
      this.loader.stop();
      this.$emit('save', res);
      this.toast.show('Cadastros agrupados com sucesso', 'success');
    }, error => {
      this.loader.stop();
      this.showToastApiError(error);
    });
  }
}
